import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxSelectBoxComponent,
    DxTextAreaComponent
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import {
    ShuntPriority,
    ShuntMoveDto,
    DataSources,
    ShuntLocationType,
} from '@services';
import { FormPopupComponent } from 'src/app/components';
import { CustomStore } from 'devextreme-aspnet-data-nojquery';
import { ShuntPriorityPipe } from 'src/app/pipes/shunt-priority.pipe';
import EnumUtils from 'src/app/shared/enum-utils';
@Component({
    selector: 'shunt-move-form',
    templateUrl: './shunt-move-form.component.html',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        FormPopupComponent,
        CommonModule,
        DxSelectBoxComponent,
        DxTextAreaComponent,
    ],
    providers: [ShuntPriorityPipe],
})
export class ShuntMoveFormComponent {
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Input() formData: ShuntMoveDto = { priority: ShuntPriority.High } as ShuntMoveDto;
    @Output() onSave = new EventEmitter();    
    @Input() titlePrefix: string | null = null;
    @Input() isReadOnly = false;

    getSizeQualifier = getSizeQualifier;

    dataSources = inject(DataSources);
    private shuntPriorityPipe = inject(ShuntPriorityPipe);
    shuntLocationDataSource!: CustomStore;

    shuntLocationOptions = EnumUtils.getEnumOptions(ShuntLocationType).filter(
        (option) => option.value !== ShuntLocationType.Office,
    );

    shuntPriorityOptions = EnumUtils.getEnumOptions(ShuntPriority, (v) =>
        this.shuntPriorityPipe.transform(v),
    );

    onLocationTypeChanged(e: any) {
        if (!this.isReadOnly) {
            this.onValueChanged(undefined);
        }
        this.loadShuntLocations();
    }

    loadShuntLocations() {
        this.shuntLocationDataSource = this.dataSources.shuntLocationOptions(
            this.formData.location as ShuntLocationType,
            this.formData.locationId,
        );
    }

    onValueChanged(locationId: any | undefined) {
        this.formData.locationId = locationId;
    }

    onPopupSaveClick(){
        this.onSave.emit();
    }

    onVisibleChange(visible: boolean) {
        this.visibleChange.emit(visible);
    }

    getData = () => new ShuntMoveDto({ ...this.formData });
}
